import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

export const SidebarContainer = styled.aside`
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(13, 24, 16, 0.98);
  backdrop-filter: blur(12px);
  display: grid;
  align-items: center;
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;
`;

export const CloseIcon = styled(FaTimes)`
  color: var(--color-cream);
  transition: color 0.2s ease;

  &:hover {
    color: var(--color-gold);
  }
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  border: transparent;
  font-size: 1.8rem;
  cursor: pointer;
  outline: none;
`;

export const SidebarWrapper = styled.div`
  color: var(--color-cream);
`;

export const SidebarMenu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 60px);
  }
`;

export const SidebarLink = styled(LinkR)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-family: var(--font-heading);
  font-weight: 600;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  color: var(--color-cream);
  cursor: pointer;
  letter-spacing: 1px;

  &:hover {
    color: var(--color-gold-light);
    transition: 0.2s ease-in-out;
  }
`;

export const SidebarExternalLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-family: var(--font-heading);
  font-weight: 600;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  color: var(--color-cream);
  cursor: pointer;
  letter-spacing: 1px;

  &:hover {
    color: var(--color-gold-light);
    transition: 0.2s ease-in-out;
  }
`;

export const SideBtnWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const SidebarRoute = styled(LinkR)`
  border-radius: 4px;
  background: var(--color-gold);
  white-space: nowrap;
  padding: 14px 56px;
  color: var(--color-off-white);
  font-size: 13px;
  font-family: var(--font-body);
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  outline: none;
  border: 2px solid var(--color-gold);
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  text-decoration: none;

  &:hover {
    background: transparent;
    color: var(--color-gold);
  }
`;

export const SidebarExternalRoute = styled.a`
  border-radius: 4px;
  background: var(--color-gold);
  white-space: nowrap;
  padding: 14px 56px;
  color: var(--color-off-white);
  font-size: 13px;
  font-family: var(--font-body);
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  outline: none;
  border: 2px solid var(--color-gold);
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  text-decoration: none;

  &:hover {
    background: transparent;
    color: var(--color-gold);
  }
`;